import { Box, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { LedDesktopNavigation, LedMobileNavigation } from 'containers/led/layouts';
import React, { FC, ReactNode } from 'react';

interface LedLayoutProps {
  children: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    paddingTop: 0,
  },
  mobileBox: {
    marginBottom: theme.spacing(21),
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
}));

const LedContent: FC<LedLayoutProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.mobileBox}>
        <LedMobileNavigation />
      </Box>
      <Box display="flex" className={classes.box}>
        <LedDesktopNavigation />
        {children}
      </Box>
    </>
  );
};

export default LedContent;
